import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltVideoEditorPlayerZoomButtonOptionsListItemWireframe from './VeltVideoEditorPlayerZoomButtonOptionsListItemWireframe/VeltVideoEditorPlayerZoomButtonOptionsListItemWireframe';
var VeltVideoEditorPlayerZoomButtonOptionsListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-zoom-button-options-list-wireframe", __assign({}, transformedProps), children));
};
VeltVideoEditorPlayerZoomButtonOptionsListWireframe.Item = VeltVideoEditorPlayerZoomButtonOptionsListItemWireframe;
export default VeltVideoEditorPlayerZoomButtonOptionsListWireframe;
